import NavLink from 'gatsby-theme-pages/src/components/nav/list-nav/nav-link';
import styled from 'styled-components';

export default styled(NavLink)`
  color: inherit;
  text-transform: uppercase;
`;
